import React, { useEffect, useState } from "react";
import useTitle from "../Hooks/useTitle";
import Datagrid from "../Components/Datagrid";
import DatagridContext from "../Context/datagridContext";
import UnauthorizePage from "./UnauthorizePage";
import ForbiddenPage from "./ForbiddenPage";
import toolbar from "../Config/toolbarConfig";
import editSettings from "../Config/editSettingsConfig";
import { useTranslation } from "react-i18next";
import { MaskedTextBoxComponent } from "@syncfusion/ej2-react-inputs";

const AdminsPage = () => {
  const [url, setUrl] = useState("");
  const [from, setFrom] = useState("");
  const [status, setStatus] = useState(null);
  const { t } = useTranslation();

  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  useTitle(`${t("Admins")} | Netileti`);
  const fetchData = async () => {
    setUrl(`${baseUrl}/admins`);
    setFrom("Admins");
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {}, [status]);

  const editTemplate = (props) => {
    return (
      <MaskedTextBoxComponent
        id={`phoneNumber_${props.rowIndex}`}
        name="phoneNumber"
        placeholder={t("Phone Number")}
        onChange={(e) => {
          if (props.onChange) {
            props.onChange({
              target: {
                name: "phoneNumber",
                value: e.value
              }
            });
          }
        }}
        mask={"+90 (000)-000-0000"}
        value={props.phoneNumber || ''}
        floatLabelType="Always"
      />
    );
  };

  const formatPhoneNumber = (value) => {
    if (!value) return '';
    const numericValue = value.replace(/[^0-9]/g, '');
    if (numericValue.length !== 12) return value;
    
    return `+${numericValue.slice(0, 2)} (${numericValue.slice(2, 5)})-${numericValue.slice(5, 8)}-${numericValue.slice(8)}`;
  };

  const columns = [
    {
      field: "id",
      headerText: "id",
      allowEditing: false,
      isPrimaryKey: true,
      visible: false,
    },
    {
      field: "name",
      headerText: t("Name"),
      allowEditing: true,
      validationRules: { required: true, maxLength: 50 },
    },
    {
      field: "email",
      headerText: t("Email"),
      allowEditing: true,
      validationRules: { required: true, maxLength: 50 },
    },
    {
      field: "phoneNumber",
      headerText: t("Phone Number"),
      allowEditing: true,
      editTemplate: editTemplate,
      template: (props) => formatPhoneNumber(props.phoneNumber)
    },
  ];

  if (!url) {
    return <div></div>;
  }
  
  return (
    <div
      className="content e-content-animation"
      style={{ display: "flex", justifyContent: "center", height: "auto" }}
    >
      {status === 401 ? (
        <UnauthorizePage />
      ) : status === 403 ? (
        <ForbiddenPage />
      ) : (
        <DatagridContext.Provider
          value={{
            editSettings,
            toolbar: toolbar("CRUD"),
            url,
            from,
            setStatus,
          }}
        >
          <Datagrid columns={columns} />
        </DatagridContext.Provider>
      )}
    </div>
  );
};

export default AdminsPage;
